<template>
    <!-- 订单查询 -->
    <div>
        <div class="order_title">
            订单查询
        </div>
        <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="输入查询：">
            <el-input
              v-model="formInline.type"
              placeholder="请输入员工姓名或电话"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item class="left_margin">
            <el-button type="primary" @click="onSubmit" class="inquire"
              >搜索</el-button
            >
            <el-button type="primary" class="reset" @click="reset">重置</el-button>
          </el-form-item>
        </el-form> -->
        <div class="TagList">
            <el-tag
                :key="tag.path"
                v-for="tag in tags"
                :disable-transitions="false"
                @click="changeMenu(tag)"
                :effect="TagsValue == tag.value ? 'dark' : 'plain'"
            >
                {{ tag.label }}
            </el-tag>
            <br/><br/>
            <el-upload
                class="upload-demo"
                action=""
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="importHourseExcel"
            >
                <el-button
                    type="primary"
                    style="border: #2f80ed;width: 72px;"
                    v-if="premission('Export:Listing:list')"
                >导入
                </el-button>
            </el-upload>
        </div>

        <!-- 房源列表模块 -->
        <el-table :data="tableData" style="width: 100%" class="margin-bottom">
            <el-table-column prop="postName" label="来源">
                <template slot-scope="scope">
                    <div class="QuickMark_box" v-if="scope.row.dataSource== 2">
                        <div class="QuickMark">
                            <img src="../../image/youjia.png" alt=""/>
                        </div>
                        <div class="QuickMark_text">悠家</div>
                    </div>
                    <div class="QuickMark_box" v-if="scope.row.dataSource== 1">
                        <div class="QuickMark">
                            <img src="../../image/youjia.png" alt=""/>
                        </div>
                        <div class="QuickMark_text">微信小程序</div>
                    </div>
                    <div class="QuickMark_box" v-if="scope.row.dataSource== 3">
                        <div class="QuickMark">
                            <img src="../../image/mt.png" alt=""/>
                        </div>
                        <div class="QuickMark_text">美团</div>
                    </div>
                    <div class="QuickMark_box" v-if="scope.row.dataSource== 4">
                        <div class="QuickMark">
                            <img src="../../image/tj.png" alt=""/>
                        </div>
                        <div class="QuickMark_text">途家</div>
                    </div>
                    <div class="QuickMark_box" v-if="scope.row.dataSource== 5">
                        <div class="QuickMark">
                            <img src="../../image/pig.png" alt=""/>
                        </div>
                        <div class="QuickMark_text">小猪</div>
                    </div>
                    <div class="QuickMark_box" v-if="scope.row.dataSource== 6">
                        <div class="QuickMark">
                            <img src="../../image/ai.png" alt=""/>
                        </div>
                        <div class="QuickMark_text">爱彼迎</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="订单编号">
                <template slot-scope="scope">
                    <div class="order_number mouse" @click="goDetails(scope.row)">
                        {{ scope.row.id }}
                    </div>
                    <div class="order_status" v-if="scope.row.orderTypes == 1">
                        线上订单
                    </div>
                    <div class="order_status" v-if="scope.row.orderTypes == 2">
                        优化单
                    </div>
                    <div class="order_status" v-if="scope.row.orderTypes == 3">
                        线下单
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="vHousTitle"
                             width="200px" show-tooltip-when-overflow
                             show-overflow-tooltip label="房间">
                <template slot-scope="scope">
                    <div class="order_number">{{ scope.row.vHousTitle }}</div>
                    <div class="order_status">运营管家：{{ scope.row.cHouSteward }}</div>
                    <div class="order_status">个人房源：{{ scope.row.customerName }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="userName" width="200px" show-overflow-tooltip label="房客">
                <template slot-scope="scope">
                    <div class="order_number">
                        {{ scope.row.userName }}（{{ scope.row.numberOfPeople }}人）
                    </div>
                    <div class="order_status">{{ scope.row.userPhone | phone }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="checkInTime"  label="入离">
                <template slot-scope="scope">
                    <div class="order_number">
                        {{ scope.row.checkInTime }}至{{ scope.row.leaveTime }}
                    </div>
                    <div class="order_status" v-if="scope.row.type == 1">待支付</div>
                    <div class="order_status" v-if="scope.row.type == 2">接单</div>
                    <div class="order_status" v-if="scope.row.type == 3">入住</div>
                    <div class="order_status" v-if="scope.row.type == 4">已入住</div>
                    <div class="order_status" v-if="scope.row.type == 5">已离店</div>
                    <div class="order_status" v-if="scope.row.type == 6">未评论</div>
                    <div class="order_status" v-if="scope.row.type == 7">已评论</div>
                    <div class="order_status" v-if="scope.row.type == 8">已取消</div>
                    <div class="order_status" v-if="scope.row.type == 9">
                        超时支付取消
                    </div>
                    <div class="order_status" v-if="scope.row.type == 10">
                        主动拒单取消
                    </div>
                    <div class="order_status" v-if="scope.row.type == 11">
                        超时拒单取消
                    </div>
                    <div class="order_status" v-if="scope.row.type == 12">退款取消</div>
                    <div class="order_status" v-if="scope.row.type == 13">主动取消</div>
                </template>
            </el-table-column>
            <el-table-column prop="money" label="合计金额">
                <template slot-scope="scope">
                    <div class="order_number">￥{{ scope.row.money }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="money" label="房费">
                <template slot-scope="scope">
                    <div class="order_number">￥{{ scope.row.originalPrice }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="money" label="押金(线下收取押金不计入合计金额)">
                <template slot-scope="scope">
                    <div class="order_number">￥{{ scope.row.deposit }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="invoiceAmount" label="途家发票金额">
                <template slot-scope="scope">
                    <div class="order_number">￥{{ scope.row.invoiceAmount||0 }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="serviceAmount" label="途家服务费">
                <template slot-scope="scope">
                    <div class="order_number">￥{{ scope.row.serviceAmount||0 }}</div>
                </template>
            </el-table-column>

            <el-table-column prop="incomeAmount" label="途家接入商收入金额">
                <template slot-scope="scope">
                    <div class="order_number">￥{{ scope.row.incomeAmount||0 }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="cMemo" label="备注"></el-table-column>
            <el-table-column label="下单时间">
                <template slot-scope="scope">
                    <div class="order_time">{{ scope.row.creationTime }}</div>
                    <div
                        class="order_time"
                        v-if="scope.row.type == 8 || scope.row.type == 9"
                    >
                        取消时间：{{ scope.row.unsubscribeTime }}
                    </div>

                    <div
                        class="order_time"
                        v-if="scope.row.type == 12 || scope.row.type == 13"
                    >
                        退款时间：{{ scope.row.cancelOrderTime }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button
                        @click="updateOrdersPut(scope.row)"
                        class="blue order_btn"
                        v-if="scope.row.type == 4"
                    >离店
                    </el-button
                    >
                    <el-button class="blue order_btn" @click="receivingOrder(scope.row)" v-if="scope.row.type == 2"
                    >接单
                    </el-button
                    >
                    <el-button @click="updateTjOrder(scope.row,'取消')" class="red order_btn" v-if="scope.row.type == 2&&scope.row.dataSource==4"
                    >取消订单
                    </el-button
                    >
                    <el-button @click="updatePigOrder(scope.row.id,0)" class="red order_btn" v-if="scope.row.type == 2&&scope.row.dataSource==5"
                    >拒单
                    </el-button
                    >
                    <el-button
                        @click="updateOrdersPut(scope.row)"
                        class="blue order_btn"
                        v-if="scope.row.type == 3"
                    >入住
                    </el-button
                    >

                    <el-button class="blue order_btn" v-if="scope.row.type == 5"
                    >已离店
                    </el-button
                    >
                    <el-button class="yellow order_btn" v-if="scope.row.type == 1"
                    >待支付
                    </el-button
                    >
                    <el-button class="yellow order_btn" v-if="scope.row.type == 7"
                    >已评论
                    </el-button
                    >
                    <el-button class="yellow order_btn" v-if="scope.row.type == 6"
                    >未评论
                    </el-button
                    >
                    <el-button class="yellow order_btn" v-if="scope.row.type == 6"
                    >未评论
                    </el-button
                    >
                    <el-button class="yellow order_btn" v-if="scope.row.type == 8"
                    >已取消
                    </el-button
                    >
                    <el-button class="red order_btn" v-if="scope.row.type == 9"
                    >超时未支付
                    </el-button
                    >
                    <el-button class="red order_btn" v-if="scope.row.type == 10"
                    >主动拒单取消
                    </el-button
                    >
                    <el-button class="red order_btn" v-if="scope.row.type == 11"
                    >超时拒单取消
                    </el-button
                    >
                    <el-button class="red order_btn" v-if="scope.row.type == 12"
                    >退款取消
                    </el-button
                    >
                    <el-button class="red order_btn" v-if="scope.row.type == 13"
                    >主动取消
                    </el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="paging">
            <div class="block">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[8, 15, 30]"
                    :page-size="8"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getOrders,
    updateOrders,
    canceledList,
    importOrdersExcel,
    updateTjOrderstatus,
    confirmPigOrder
} from "../../api/index";
import { format } from "@/utils/util.js"
import premission from "../../utils/permission";

export default {
    mixins: [premission],
    filters: {
        phone: function (item) {
            if (item == null) return;
            return item.substr(0, 3) + "****" + item.substr(7);
        }
    },
    data() {
        return {
            currentPage: 1,
            total: 1,
            // 切换按钮
            TagsValue: "3",
            tags: [
                // { value: "0", label: "有效订单" }, //flag
                {value: "1", label: "待支付"}, //type
                {value: "2", label: "待确认"},
                {value: "3", label: "待入住"},
                {value: "4", label: "已入住"},
                {value: "5", label: "已完成"},
                {value: "8", label: "已取消"},
               // {value: "9", label: "超时未支付"}
            ],
            formInline: {
                phone: window.sessionStorage.getItem("Phone") || "",
                // phone: "15327094801",
                pageNum: 1,
                pageSize: 8,
                type: 3,
                flag: 1,
                params:{}
            },
            tableData: [],
            modifyOrder: {
                id: "",
                type: ""
            }
        };
    },
    created() {
        //this.getOrdersGet();
        this.canceledList();
    },
    methods: {
        async getOrdersGet() {
            const {data: res} = await getOrders(this.formInline);
            this.tableData = res.rows.map(item => {
                item.checkInTime = format("{y}-{m}-{d} {h}:{i}:{s}",new Date(item.checkInTime));
                item.leaveTime = format("{y}-{m}-{d} {h}:{i}:{s}",new Date(item.leaveTime));
                item.creationTime = format("{y}-{m}-{d} {h}:{i}:{s}",new Date(item.creationTime));
                return item;
            });
            this.total = res.total;
        },
        changeMenu(tag) {
            this.formInline.type = tag.value;
            this.TagsValue = tag.value;
            if (tag.value == 8||tag.value == 9) {
                this.formInline.flag = "0";
                //this.canceledList();
            } else {
                this.formInline.flag = "1";
               // this.getOrdersGet();
            }
            this.canceledList();


        },
       canceledList(){
            this.formInline.params['flag']=this.formInline.flag;
            this.formInline.params['type']=this.formInline.type;
            this.formInline.params['cStewardId']=sessionStorage.getItem('userId')==1?'':sessionStorage.getItem('userId')
            delete  this.formInline.type
            delete  this.formInline.flag
            canceledList(this.formInline).then(({data})=>{
                console.log(data)
                this.tableData = data.data.rows.map(item => {
                    item.dataSource=item.dataSources;
                    item.cHouSteward=item.chouSteward;
                    item.vHousTitle=item.vhousTitle;
                    item.customerName=item.customer_name;
                    item.checkInTime = format("{y}-{m}-{d} {h}:{i}:{s}",new Date(item.checkInTime));
                    item.leaveTime = format("{y}-{m}-{d} {h}:{i}:{s}",new Date(item.leaveTime));
                    item.creationTime = format("{y}-{m}-{d} {h}:{i}:{s}",new Date(item.creationTime));

                    return item;
                });
                this.total = data.data.total;
                this.formInline.type= this.formInline.params.type;
                this.formInline.flag=this.formInline.params.flag;
                this.tableData.forEach(async (item)=>{
                    if(item.dataSource== 4&&item.type==5){
                        let from = {
                            orderId:item.id,
                            partner_oid:item.id,
                            order_status:7,
                            order_status_desc:'已离店'
                        }


                        const {data: res2} = await updateTjOrderstatus(from);
                        if(res2.code!=200){
                            return this.$message.error(res2.msg)
                        }
                    }
                })
            })
        },
        async updateOrdersPut(e) {
            // 入住：发4
            // 离店：发5
            if (e.type == 3) {
                this.modifyOrder.type = 4;
            }
            if (e.type == 4) {
                this.modifyOrder.type = 5;
            }
            this.modifyOrder.id = e.id;
            /*let from = {
                orderId:e.id,
                partner_oid:e.id,
                order_status:this.modifyOrder.type==4?6:7,
                order_status_desc:this.modifyOrder.type==4?'已入住':'已离店'
            }
            console.log(e,from)

            const {data: res2} = await updateTjOrderstatus(from);
            if(res2.code!=200){
                return this.$message.error(res2.msg)
            }*/
            const {data: res} = await updateOrders(this.modifyOrder);
            this.getOrdersGet();
            if (res.code !== 200)
                return this.$message({
                    message: res.msg,
                    type: "error"
                });
        },
        onSubmit() {
        },
        reset() {
        },
        goDetails(e) {
            this.$router.push({
                name: "orderDetails", //跳转的路径
                params: {
                    orderNumber: e.id
                }
            });
        },
        // 分页
        handleSizeChange(val) {
            this.formInline.pageSize = val;
           /* if(this.TagsValue==8||this.TagsValue==9){
                this.canceledList();
            }else {
                this.getOrdersGet();
            }*/
            this.canceledList();
        },
        handleCurrentChange(val) {
            this.formInline.pageNum = val;
           /* if(this.TagsValue==8||this.TagsValue==9){
                this.canceledList();
            }else {
                this.getOrdersGet();
            }*/
            this.canceledList();

        },
        //导入
        importHourseExcel(data){
            console.log(data)
            let fromData=new FormData();
            fromData.append("file",data.raw)

            importOrdersExcel(fromData).then(res=>{
                console.log(res)
                if(res.data.code==0){
                    this.$message.success('导入成功')
                    this.LandlordAjaxList();
                }else {
                    this.$message.error(res.data.msg)
                }

            })
        },
        //接单
        async receivingOrder(row){
            console.log(row)
            let re = {}
            if(row.dataSources ==4){
              //  途家接单
                const {data: res } = await  this.updateTjOrder(row,'接单');
                re = res
            }else if(row.dataSources == 5){
                 //  小猪接单
                const {data: res } = await this.updatePigOrder(row.id,1);
                re = res
            }
            console.log(re)
            if(re.code!=200)
                return this.$message.error(re.msg)
            const {data: res} = await updateOrders({
                id:row.id,
                type:3,
            });
            this.getOrdersGet();
        },
        async updatePigOrder(orderId,confirm){
            // confirm 1接单 0拒单
            // rejectType 0没有房间 1价格不正确 2预订天数太少 3预订日期超出时间限制 4 其他原因
            let from={
                orderId,
                confirm:confirm
            }
            let that = this;
            if(confirm==0){
                from['rejectType'] = 4; //拒绝类型
                from['rejectReason'] = '悠家主动取消';//拒绝理由
                this.$confirm('确定拒单吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const {data:res} =  await confirmPigOrder(from);
                    if(res&&res.code==200){
                        that.$message.success('拒单成功')
                    }else {
                      return  that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }

                }).catch(() => {

                });

            }else {
                return confirmPigOrder(from)
            }

        },
       async updateTjOrder(item,type){
            //item.houseId,
            let from = {
                orderId:item.id,
                partner_oid:item.id,
                order_status:type=='接单'?1:2,
                order_status_desc:type=='接单'?'待入住':'已取消',
                yjOrderStatus:type=='接单'?3:8,
            }

            let that = this;
            if(type!='接单'){
                this.$confirm('确定取消订单吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const {data:res} =  await updateTjOrderstatus(from);
                    if(res&&res.code==200){
                        that.$message.success('取消成功')
                        const {data: re} = await updateOrders({
                            id:item.id,
                            type:type=='接单'?3:8,
                        });
                        that.getOrdersGet();
                    }else {
                        return  that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }

                }).catch(() => {

                });
            }else {
                return updateTjOrderstatus(from);

            }




        }
    }
};
</script>

<style lang="less" scoped>
.TagList {
    margin-bottom: 30px;
    height: 106px;
    border-bottom: 1px solid #e1e1e1;
}

.el-tag--plain {
    cursor: pointer;
    width: 96px;
    height: 36px;
    line-height: 34px;
    font-size: 16px;
    text-align: center;
    margin-right: 50px;
    border: 1px solid #e1e1e1;
    color: #666666;
}

.mouse {
    cursor: pointer;
}

.el-tag--dark {
    cursor: pointer;
    width: 96px;
    height: 36px;
    line-height: 34px;
    font-size: 16px;
    text-align: center;
    margin-right: 50px;
}

.order_title {
    width: 72px;
    height: 24px;
    font-size: 18px;
    line-height: 24px;
    color: #171a1e;
    margin-bottom: 20px;
}

/deep/ .demo-form-inline {
    .el-input__inner {
        width: 200px;
        height: 36px;
        font-size: 14px;
    }

    .left_margin {
        margin-left: 26px;
    }

    .inquire {
        width: 72px;
        height: 36px;
        margin-top: 2px;
        margin-left: -12px;
    }

    .el-button + .el-button {
        margin-left: 24px;
        width: 72px;
        height: 36px;
        background: #f6b439;
        border: 1px solid #f6b439;
    }
}

/deep/ .el-table th {
    font-family: Microsoft YaHei;
    font-style: normal;
    font-weight: normal;
    text-align: center;
    background-color: #f2f2f2;
}

/deep/ .el-table__row td {
    text-align: center;
    height: 60px;
    padding: 4px 0;
}

.QuickMark_box {
    width: 100%;
    height: 101px;
    position: relative;
}

.QuickMark {
    position: absolute;
    top: 20px;
    left: 50%;

    transform: translateX(-50%);
    width: 40px;
    height: 40px;

    img {
        width: 40px;
        height: 40px;
    }
}

.QuickMark_text {
    font-size: 14px;
    line-height: 150px;
    color: #000000;
}

.order_number {
    font-size: 14px;
    color: #000000;
}

.order_time {
    font-size: 12px;
    color: #000000;
}

.order_status {
    font-size: 12px;
    color: #666666;
}

.order_btn {
    width: 72px;
    height: 30px;
    padding: 0;
    color: #fff;
    border-radius: 4px;
}

.yellow {
    background-color: #f6b439;
    border: #f6b439;
}

.blue {
    background-color: #2f80ed;
    border: #2f80ed;
}

.red {
    background-color: #f62a2a;
    border: #f62a2a;
}

.paging {
    position: absolute;
    bottom: 52px;
    left: 50%;
    transform: translateX(-50%);
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #f6b439;
}

.margin-bottom {
    margin-bottom: 100px;
}
</style>
